<template>
    <b-card :class="{'d-flex flex-row':true}" no-body>
        <div class="d-flex">
            <img :src="clientImage(data)" class="list-thumbnail responsive border-0"
                 style="object-fit: cover; max-width: 100px;"
                 :alt="data.data.attributes.name"/>
        </div>

        <div class="pl-2 d-flex flex-grow-1 min-width-zero">
            <div
                class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <div class="w-40 w-sm-100">
                    <p class="list-item-heading mb-0 truncate">{{data.data.attributes.name}}</p>
                    <b-card-text class="text-muted text-small">{{data.data.attributes.gender}}</b-card-text>
                </div>

                <p class="mb-0 text-muted text-small w-30 w-sm-100" title="SSN">{{data.data.attributes.ssn}}</p>

                <p class="mb-0 text-muted text-small w-15 w-sm-100" title="Date of Birth">{{data.data.attributes.dob}}</p>
            </div>

            <div class="custom-control custom-checkbox pl-1 align-self-center pr-4">
                <b-button size="xs" variant="danger" @click="$emit('delete', data)">Delete</b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
    export default {
        props: ['data'],

        methods: {
            clientImage(member) {
                if (member.data.attributes.image !== 'Not Assigned') {
                    return '/storage/images/clients_families/' + member.data.attributes.image;
                }

                if ((member.data.attributes.gender).toLowerCase() === 'male') {
                    return '/default/gender_male.png';
                } else if ((member.data.attributes.gender).toLowerCase() === 'female') {
                    return '/default/gender_female.png';
                } else {
                    return '/default/gender_unknown.png';
                }
            },
        }
    }
</script>
